import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDrag = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 608,
	height: 432,
	viewBox: "0 0 608 432",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M133.161 309.225L567.784 309.225C589.776 309.225 607.604 291.397 607.604 269.405V39.8264C607.604 17.8348 589.776 0.00714111 567.784 0.00714111L133.161 0.00714111C111.169 0.00714111 93.3417 17.8348 93.3417 39.8264V269.405C93.3417 291.397 111.169 309.225 133.161 309.225Z",
			fill: "#8348E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M448.822 244.541H552.971V0.0113068H448.822V244.541Z",
			fill: "#EBE7F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M216.261 120.834L295.133 120.834V0.00359344L216.261 0.00359344V120.834Z",
			fill: "#BA93FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M130.316 261.373H242.552L242.552 0.000549316H130.316L130.316 261.373Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M368.181 188.574H481.938V0.00164795H368.181V188.574Z",
			fill: "#BA93FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M342.644 216.725H422.777V0.00654602H342.644V216.725Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M286.466 60.916H86.4794C64.4923 60.916 46.6602 78.7357 46.6602 100.735V172.905C66.0875 181.351 106.302 195.498 156.151 188.251C174.168 185.629 203.192 181.054 231.127 159.722C275.225 126.049 284.376 75.2732 286.454 60.9284L286.466 60.916Z",
			fill: "#8348E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M521.113 60.916H286.464C283.595 71.5633 265.293 135.435 199.95 169.665C126.384 208.198 55.0676 176.775 46.6709 172.905V278.475C73.4561 265.342 116.713 247.98 171.298 244.221C277.524 236.887 326.172 287.96 406.318 275.841C445.197 269.967 500.647 247.831 560.933 168.502V100.748C560.933 78.7605 543.113 60.9284 521.113 60.9284V60.916Z",
			fill: "#BA93FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M356.556 270.53C300.562 270.691 267.581 237.166 190.008 238.019C128.511 238.7 78.6997 260.538 46.6836 278.482V330.333C46.6836 352.32 64.5033 370.153 86.5028 370.153H521.138C543.126 370.153 560.958 352.333 560.958 330.333C560.958 261.082 560.958 191.819 560.958 122.568C475.458 244.524 405.502 270.394 356.581 270.543L356.556 270.53Z",
			fill: "#EBE7F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M161.691 200.204C185.308 200.204 204.454 181.059 204.454 157.442C204.454 133.825 185.308 114.68 161.691 114.68C138.074 114.68 118.929 133.825 118.929 157.442C118.929 181.059 138.074 200.204 161.691 200.204Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M474.443 121.848H39.8192C17.8277 121.848 0 139.675 0 161.667V391.246C0 413.237 17.8277 431.065 39.8192 431.065H474.443C496.434 431.065 514.262 413.237 514.262 391.246V161.667C514.262 139.675 496.434 121.848 474.443 121.848Z",
			fill: "#EBE7F2"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M234.033 291.266H280.221C314.772 291.266 342.819 319.312 342.819 353.863V431.301H171.436V353.863C171.436 319.312 199.482 291.266 234.033 291.266Z",
			fill: "#BA93FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M326.001 173.707L318.928 226.276L264.727 194.989L306.722 162.578C315.23 156.011 327.423 163.048 325.989 173.707H326.001Z",
			fill: "#BA93FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M188.254 173.707L195.327 226.276L249.529 194.989L207.533 162.578C199.025 156.011 186.832 163.048 188.266 173.707H188.254Z",
			fill: "#BA93FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M276.77 197.645H237.482C219.527 197.645 204.972 212.2 204.972 230.155V269.443C204.972 287.398 219.527 301.954 237.482 301.954H276.77C294.725 301.954 309.281 287.398 309.281 269.443V230.155C309.281 212.2 294.725 197.645 276.77 197.645Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M268.038 177.508H246.212C213.429 177.508 186.755 204.182 186.755 236.965V258.791C186.755 266.495 194.57 272.357 206.454 276.438V258.915C206.454 238.547 222.963 222.039 243.33 222.039H270.932C291.299 222.039 307.808 238.547 307.808 258.915V276.438C319.692 272.357 327.507 266.483 327.507 258.791V236.965C327.507 204.169 300.833 177.508 268.05 177.508H268.038Z",
			fill: "#8348E8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M236.567 248.973H235.108C233.414 248.973 232.041 250.346 232.041 252.039V268.289C232.041 269.982 233.414 271.356 235.108 271.356H236.567C238.261 271.356 239.634 269.982 239.634 268.289V252.039C239.634 250.346 238.261 248.973 236.567 248.973Z",
			fill: "#BA93FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M279.143 248.973H277.684C275.99 248.973 274.617 250.346 274.617 252.039V268.289C274.617 269.982 275.99 271.356 277.684 271.356H279.143C280.837 271.356 282.21 269.982 282.21 268.289V252.039C282.21 250.346 280.837 248.973 279.143 248.973Z",
			fill: "#BA93FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M115.02 231.25C115.02 212.688 99.9699 197.639 81.4082 197.639C99.9699 197.639 115.02 182.589 115.02 164.027C115.02 182.589 130.069 197.639 148.631 197.639C130.069 197.639 115.02 212.688 115.02 231.25Z",
			fill: "#BA93FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M400.074 328.703C400.074 317.264 390.799 308.002 379.373 308.002C390.812 308.002 400.074 298.727 400.074 287.301C400.074 298.74 409.349 308.002 420.775 308.002C409.336 308.002 400.074 317.277 400.074 328.703Z",
			fill: "#BA93FF"
		})
	]
});
export default SvgDrag;
